export type Args = {
  url: string

  headers?: HeadersInit,
  // onProgress?: (percent: number) => void
  // onDone?: (blob: Blob) => void
  // onStart?: () => void
  // onFailure?: (err: any) => void
  // onEnd?: () => void
}

const __success_status = [200, 304]

export default DEngine
async function DEngine(opt: Args) {
  const {
    url,
    headers = {},
    // onProgress = () => undefined,
    // onDone = () => undefined,
    // onStart = () => undefined,
    // onFailure = () => undefined,
    // onEnd = () => undefined
  } = opt

  const res = await fetch(url, { headers, redirect: 'manual', credentials: 'omit' })
  if (res.status === 0) {
    throw new Error('network error: res.status = 0')
  } else if (res.status === 302 || res.status === 301) {
    const redirect_url = res.headers.get('Location')
    if (typeof redirect_url !== 'string' || redirect_url.length === 0) {
      throw new Error('redirect url invalid')
    } else {
      return await DEngine({
        ...opt,
        url: redirect_url,
        headers: { ...headers, 'Origin': window.location.origin }
      })
    }
  } else if ( !__success_status.includes(res.status) ) {
    throw new Error(`fetch failed: ${res.status}`)
  } else {
    return await res.blob()
  }
}
